import { render } from "./Pagamento.vue?vue&type=template&id=21ae8725"
import script from "./Pagamento.vue?vue&type=script&lang=js"
export * from "./Pagamento.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__